<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<path
		d="m8.494 2.622 5.43 9.513a.58.58 0 0 1-.209.788.56.56 0 0 1-.285.077H2.57a.56.56 0 0 1-.494-.288.58.58 0 0 1 0-.577l5.43-9.513A.57.57 0 0 1 8 2.333a.56.56 0 0 1 .494.289M7.43 10.117v1.153h1.14v-1.153zm0-4.036v2.883h1.14V6.08z"
	/>
</svg>
